import styled from "styled-components";
import { IThemeProps } from "component/theme";
import { Grid } from "@mui/material";

export const StyledDelegatedUser = styled(Grid)`
    ${({theme}: IThemeProps) => `
    background-color: ${theme.uptimeColors.grayScales.grayishBackground};
    border-radius: 8px;
    padding: 6px;
    margin-top: 12px;
    .user-status{
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 10px;
        .icon-success{
            color: ${theme.uptimeColors.generalColors.state.success.light};
            font-size: 24px;
        }
    }
    .user-wrapper{
        padding: 8px 4px;
        display: grid;
        grid-template-columns: 11fr 1fr;
        grid-column-gap: 20px;
        .user-delegated{
            position: relative;
            white-space: nowrap;
        }
        .user-name{
            max-width: 162px;
            overflow-y: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            font-weight: 400;
            font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
            line-height: ${theme.uptimeLineHeights.desktop.lh1}px;
            height: 100%;
            top: ${theme.uptimeSpace[3]}px;
            margin-left: ${theme.uptimeSpace[2]}px;
            position: absolute; 
            &::-webkit-scrollbar {
                display:none;
              }
            &::-webkit-scrollbar-thumb {
                display: none;
              }
            ::-webkit-scrollbar-button {
                width: 0;
                height: 0;
                display: none;
              }
            ::-webkit-scrollbar-corner {
                background-color: transparent;
                display: none;
              }
        }  
    }
    .btn-remove{
        padding: 0px;
    }
    .MuiIconButton-root {
        font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
        font-weight: 600;
        color: ${theme.uptimeColors.mainTheme.primary};
        word-break: keep-all;
        min-width: 60px;
    }
    `}

`;
